import React, { useContext } from 'react';
import {
  Checkbox,
} from '@mui/material';
import QuantityInput from 'components/QuantityInput';
import { modifierContext } from '../../ModifierProvider';
import {
  getModifierMaxSelections,
  isAutoApplied,
} from '../../utils';
import OptionRow from '../OptionRow';

function MultiSelectModifier({ modifier, disabled }) {
  const { options } = modifier;
  const maxSelections = getModifierMaxSelections(modifier) || Number.MAX_VALUE;
  const {
    isSelected, handleChange, getTotalQty, getSelectedOption,
  } = useContext(modifierContext);

  function renderOption(option) {
    const { supports_multiple_quantity: supportMultipleQty } = option;
    const selected = isSelected({ option, modifier });
    const qty = getSelectedOption({ option, modifier })?.qty ?? 0;
    const otherQty = getTotalQty(modifier) - qty;
    const maxQty = Math.min(maxSelections - otherQty, option.max_qty || Number.MAX_VALUE);

    // Todo move this outside of render function
    if (isAutoApplied(modifier) && !selected) {
      handleChange({ modifier, option, value: { ...option, qty: 1 } });
    }
    if (supportMultipleQty) {
      return (
        <OptionRow key={option.id} option={option} htmlFor="invalid-id">
          <QuantityInput
            value={qty}
            min={0}
            max={maxQty}
            onChange={(qty) => {
              if (qty === 0) {
                return handleChange({ option, modifier, value: undefined });
              }
              handleChange({ option, modifier, value: { ...option, qty } });
            }}
            disabled={disabled}
            data-testid={`item-modifier-quantity-${option.id}`}
          />
        </OptionRow>
      );
    }
    return (
      <OptionRow key={option.id} option={option}>
        <Checkbox
          checked={isSelected({ option, modifier })}
          onChange={() => {
            if (selected) {
              return handleChange({ option, modifier, value: undefined });
            }
            handleChange({ option, modifier, value: { ...option, qty: 1 } });
          }}
          disabled={
            disabled || (maxQty === 0 && !isSelected({ modifier, option }))
          }
          data-testid={`item-modifier-checkbox-${option.id}`}
        />
      </OptionRow>
    );
  }

  return options.map(renderOption);
}

export default MultiSelectModifier;
